import { BehaviorSubject } from 'rxjs'
import { RxJS } from './RxJS'
import { MainMenuApp } from '../../constants/AppMenuConstants'
import { RxJSStateDefinable } from '../Types/Types'

const appMenuSubject: BehaviorSubject<Definable<MainMenuApp>> = new BehaviorSubject<Definable<MainMenuApp>>(undefined)

RxJS.appMenuUpdate = RxJS.appMenuUpdate ?? {
    subject: appMenuSubject,
    observable: appMenuSubject.asObservable(),
    announce: (mainMenuApp?: MainMenuApp): void => {
        appMenuSubject.next(mainMenuApp)
    }
}

export const appMenuUpdate$: RxJSStateDefinable<MainMenuApp> = RxJS.appMenuUpdate
